import CustomAuth from './CustomAuth'

export default CustomAuth
